import LoginBienvenida from './../../components/organisms/LoginBienvenida';
import './login.scss';

const Login = () => {
  return (
    <div role="main" data-landmark-index="4">
      <LoginBienvenida />
    </div>
  )
}
export default Login
